export default __webpack_public_path__ + "static/media/beauty.940c72da.jpg";